const ROWS = [
    ['Supplier', 'Locals Headquarters Pty Ltd'],
    ['Apparel Lead Time', 'Approximately 6–8 weeks from order confirmation'],
    ['Mat Lead Time', 'Approximately 6–8 weeks from order confirmation'],
    ['Delivery', 'All orders delivered directly to your academy by Locals HQ'],
    ['Minimum Order', 'No minimum per size — order what you need'],
    ['Embroidery', 'Standard Locals branding included on all apparel'],
    ['Payment', 'Stripe checkout · invoice issued by Locals HQ on confirmation'],
    ['Returns', 'All returns and defects handled through Locals HQ'],
    ['Enquiries', 'Contact Locals HQ directly for all order enquiries'],
];

export default function Supplier() {
    return (
        <div data-testid="supplier-page">
            <div className="font-mono-data text-xs uppercase text-crimson tracking-widest mb-2">Official Supplier</div>
            <h1 className="font-display text-4xl uppercase tracking-tighter mb-3">Locals Headquarters Pty Ltd</h1>
            <p className="font-body text-zinc-300 max-w-3xl mb-10">
                Sole supplier for apparel and training equipment across the Locals Jiu Jitsu franchise network — Gi
                uniforms, rashguards, rank belts, T-shirts and tatami mats. All orders placed through this portal
                are fulfilled directly by Locals HQ.
            </p>

            <div className="flex flex-wrap gap-2 mb-12">
                {['Gi Uniforms', 'Rashguards', 'Rank Belts', 'T-Shirts', 'Tatami Mats', 'Custom Embroidery', 'Franchise Network']
                    .map((t) => (
                        <span key={t} className="px-3 py-1.5 border border-zinc-800 bg-surface font-mono-data text-xs uppercase">{t}</span>
                    ))}
            </div>

            <section className="border-hairline mb-12">
                <div className="p-5 border-b border-zinc-800">
                    <h2 className="font-display text-2xl uppercase tracking-tighter">Key Info for Academies</h2>
                </div>
                {ROWS.map(([k, v]) => (
                    <div key={k} className="grid grid-cols-12 px-5 py-3 border-b border-zinc-800/60 last:border-0">
                        <div className="col-span-4 font-mono-data text-xs uppercase text-zinc-500">{k}</div>
                        <div className="col-span-8 font-body text-sm">{v}</div>
                    </div>
                ))}
            </section>

            <section className="border-hairline p-8 bg-gradient-to-br from-surface to-ink">
                <div className="font-mono-data text-xs uppercase text-crimson tracking-widest mb-2">New academy joining the network?</div>
                <h3 className="font-display text-3xl uppercase tracking-tighter mb-3">Get your portal access.</h3>
                <p className="font-body text-zinc-300 max-w-2xl">
                    Locals HQ can provision a new academy login in minutes. Once activated, your academy can place orders,
                    track payment status and download CSV manifests. Contact HQ to request access.
                </p>
            </section>
        </div>
    );
}
